@use "Styles/mixins";
@use "Styles/includes/variables";

:host {
    display: block;
    font-family: variables.$fontQuaternary;
}

.vm-video-education-events {
    display: flex;
    flex-direction: column;
    gap: 6px;

    &__title {
        margin: 0;
        font-size: mixins.get-font-size(text-md);
        line-height: mixins.get-line-height(text-md);
        font-weight: 400;
        color: mixins.get-color(text, text-primary);
    }

    &__list {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    // Collapsed: show only the first event card.
    &[data-collapsed] &__list ::slotted(vm-video-education-event-card:not(:first-child)) {
        display: none;
    }

    &__toggle {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        align-self: center;
        margin: 0;
        border: none;
        background: none;
        cursor: pointer;
        font-size: mixins.get-font-size(text-sm);
        line-height: mixins.get-line-height(text-sm);
        font-weight: 700;
        color: mixins.get-color(text, text-secondary);
    }
}
